var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6431 18.8888H19.0931L18.6288 15.1096H11.5995L10.6431 18.8888Z",
    fill: "#ECF4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8866 11.711C15.8404 11.711 16.6137 10.9377 16.6137 9.98386C16.6137 9.02998 15.8404 8.25671 14.8866 8.25671C13.9327 8.25671 13.1594 9.02998 13.1594 9.98386C13.1594 10.9377 13.9327 11.711 14.8866 11.711Z",
    fill: "#ECF4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56665 19.0467V22.1574H23.0767V5.79598C23.0767 5.10884 22.5195 4.5517 21.8324 4.5517H6.56665V7.48598",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56665 9.48242V17.4867",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 18.8888V15.9824C18.6289 15.3231 18.0996 14.7938 17.4404 14.7938H12.2032C11.5439 14.7938 11.0146 15.3231 11.0146 15.9824V18.8888",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8218 12.0917C15.8782 12.0917 16.7347 11.2353 16.7347 10.1788C16.7347 9.12241 15.8782 8.26599 14.8218 8.26599C13.7654 8.26599 12.9089 9.12241 12.9089 10.1788C12.9089 11.2353 13.7654 12.0917 14.8218 12.0917Z",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78321 8.62812H4.79321L5.21107 7.46741H7.78321V8.62812Z",
    fill: "#24293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78321 18.1367H4.79321L5.21107 16.976H7.78321V18.1367Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLead);
export default __webpack_public_path__ + "static/media/lead.10f60e2fbbc3615144dc38ab4781565a.svg";
export { ForwardRef as ReactComponent };